export default "__VITE_ASSET__DuNvXISk__"